import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

import { useLogo } from 'reservations/account/hooks/UseLogo';
import useIsDesktop from 'reservations/base/hooks/useIsDesktop';

type ImageProps = {
  isDesktop: boolean;
};
const Image = styled('img')<ImageProps>(({ isDesktop }) => ({
  objectFit: 'contain',
  minHeight: '70px',
  maxHeight: '120px',
  minWidth: '70px',
  maxWidth: isDesktop ? '560px' : '300px'
}));

export const LogoOnlyLayout = () => {
  const logo = useLogo();

  const isDesktop = useIsDesktop();
  return (
    <Box
      data-testid="logo-only-layout"
      sx={{
        width: '100%'
      }}
    >
      <Paper
        data-testid="logo-wrapper"
        sx={{
          backgroundColor: 'transparent',
          width: 'inherit',
          boxShadow: 0,
          display: 'flex',
          justifyContent: isDesktop ? 'start' : 'flex-center'
        }}
      >
        <Image
          isDesktop={isDesktop}
          src={logo?.url}
          alt={logo?.alt_text}
          data-testid="logo-image"
        />
      </Paper>
    </Box>
  );
};
